export const OPTIONS_LOADING = 'OPTIONS_LOADING';
export const OPTIONS_FULFILLED = 'OPTIONS_FULFILLED';
export const OPTION_FULFILLED = 'OPTIONS_FULFILLED';
export const OPTIONS_UPDATED = 'OPTIONS_UPDATED';
